import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import ReviewStep from './Components/ReviewStep'
import LoadingStep from './Components/LoadingStep'
import DetailsStep from './Components/DetailsStep'
import EditDetailsStep from './Components/EditDetailsStep'

class CollectionCreationModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: this.getStep(props),
      itemIds: props.selectedItems.map(item => item.id),
      collectionData: {},
      collectionImages: [],
      collectionEmbeds: [],
      collectionPrice: 0,
    }

    this.onModalClose = this.onModalClose.bind(this)
    this.changeStep = this.changeStep.bind(this)
  }

  getStep(props) {
    if (props.isAddingToCollection) {
      return 'loading'
    }

    return props.editableCollectionId !== '' ? 'details' : 'review'
  }

  onModalClose() {
    this.setState({ step: 'review' })
    this.props.closeModal()
  }

  changeStep(step, ids, data, images, embeds) {
    this.setState(prevState => ({
      step,
      itemIds: ids,
      collectionData: data || prevState.collectionData,
      collectionImages: images || prevState.collectionImages,
      collectionPrice: data ? data.attributes.modelsPrice : prevState.collectionPrice,
      collectionEmbeds: embeds || prevState.collectionEmbeds,
    }))
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--large-closable',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal overlay-modal--folders-structure-review">
          {this.state.step === 'review'
            && (
            <ReviewStep
              itemIds={this.state.itemIds}
              onModalClose={this.onModalClose}
              changeStep={this.changeStep}
            />
            )
          }

          {this.state.step === 'loading'
            && (
            <LoadingStep
              itemIds={this.state.itemIds}
              selectedItems={this.props.selectedItems}
              onModalClose={this.onModalClose}
              changeStep={this.changeStep}
              isAddingToCollection={this.props.isAddingToCollection}
              collectionId={this.props.editableCollectionId}
            />
            )
          }

          {this.state.step === 'details' && (
            this.props.editableCollectionId !== '' ? (
              <EditDetailsStep
                onModalClose={this.onModalClose}
                editableCollectionId={this.props.editableCollectionId}
              />
            ) : (
              <DetailsStep
                onModalClose={this.onModalClose}
                data={this.state.collectionData.attributes}
                images={this.state.collectionImages}
                embeds={this.state.collectionEmbeds}
                suggestedPrice={this.state.collectionPrice}
              />
            )
          )}
        </div>
      </Modal>
    )
  }
}

CollectionCreationModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired,
  editableCollectionId: PropTypes.string.isRequired,
  isAddingToCollection: PropTypes.bool.isRequired,
}

export default CollectionCreationModal
